class SourceUpdatesAttributeChangeRow {
    constructor(
        public changeLogId: string = "",
        public attributeName: string = "",
        public itemId: string = "",
        public sourceId: string = "",
        public sourceName: string = "",
        public changedAt: string = "",
        public changeType: string = "",
        public oldValue?: string | null,
        public newValue?: string | null,
        public normalizedSimilarity?: number | null,
        public numericDifference?: number | null
    ) {
    }

    public static fromPOJO(data: any) {
        return new SourceUpdatesAttributeChangeRow(
            data?.changeLogId ?? "",
            data?.attributeName ?? "",
            data?.itemId ?? "",
            data?.sourceId ?? "",
            data?.sourceName ?? "",
            data?.changedAt ?? "",
            data?.changeType ?? "",
            data?.oldValue,
            data?.newValue,
            data?.normalizedSimilarity,
            data?.numericDifference
        );
    }
}

export default SourceUpdatesAttributeChangeRow;
